import { ExtensionURLs } from "@clockwise/web-commons/src/constants/stores.constant";
import React from "react";
import { TrackingEvents, track } from "../../../../util/analytics.util";
import Chrome from "./assets/Chrome.svg";

export const RecommendedApps = ({ goForward }: { goForward: () => void }) => {
  const openChromeStore = () => {
    track(TrackingEvents.WEB_ONBOARDING.DOWNLOAD_CONFIRMATION_SLACK);
    window.open(ExtensionURLs.chrome, "_blank");
    goForward();
  };
  return (
    <div className="cw-flex cw-flex-col cw-w-full cw-items-center cw-mt-16 cw-mb-10">
      <div className="cw-flex cw-items-center cw-justify-center cw-w-full md:cw-w-[650px] cw-mb-4">
        <div className="cw-border cw-border-x-0 cw-border-t-0 cw-border-solid cw-border-default cw-flex-1" />
        <div className="cw-heading-base cw-text-center cw-px-4"> Other Recommended Apps </div>
        <div className="cw-border cw-border-x-0 cw-border-t-0 cw-border-solid cw-border-default cw-flex-1" />
      </div>

      <div
        onClick={openChromeStore}
        className="cw-mt-6 cw-flex cw-flex-col cw-items-center cw-cursor-pointer cw-border cw-border-solid cw-border-default cw-rounded-lg cw-py-4 cw-px-10"
      >
        <div className="">
          <img className="cw-w-[90px]" src={Chrome} />
        </div>
        <div className="cw-heading-base cw-py-2"> Chrome Extension </div>
      </div>
    </div>
  );
};
